import { message as antdMessage } from "antd"
import React, {
  ComponentType,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react"
import { Toast } from "react-vant"
import { MediaQueryContext } from "libs/contexts"
import { authSubject } from "api/user"
import { createContext } from "react"

export const AuthSubjectContext = createContext({
  catchRejection: function <T extends (...args: any) => Promise<any>>(fn: T) {
    type Result = T extends (...args: any) => Promise<infer R> ? R : any
    return (...args: Parameters<T>) => {
      return fn(...args) as Promise<Result>
    }
  },
})
AuthSubjectContext.displayName = "AuthSubjectContext"

export interface PwdEntryInterface {
  id: string
  error?: any
  submitForm: (..._: any) => void
}

export default function AuthSubjectBoundry({
  children,
  id,
  Entry,
}: {
  id: string
  children: ReactNode
  Entry: ComponentType<PwdEntryInterface>
}) {
  const { isMobile } = useContext(MediaQueryContext)
  const [err, setErr] = useState(null)

  const message = isMobile ? Toast.fail : antdMessage.error

  function authHandler(e: APIJSON) {
    if (e.code === 200) {
      setErr(null)
    } else if (e.code === 400106) {
      setErr({
        code: e.code,
        message: "",
      })
    } else if (e.code === 400107 || e.code === 400108) {
      setErr({
        code: e.code,
        message: e.message,
      })
    } else {
      setErr(null)
      message(e.message)
    }
  }

  function auth(password: string) {
    authSubject(id, password)
      .then((res) => {
        authHandler(res)
      })
      .catch((e) => authHandler(e))
  }

  function catchRejection<T extends (...args: any) => any>(fn: T) {
    return async (...args) => {
      try {
        const res = await fn(...args)
        return res
      } catch (error) {
        // console.log("catchRejection: ", error)
        authHandler(error)
      }
    }
  }

  return (
    <AuthSubjectContext.Provider
      value={{
        catchRejection,
      }}
    >
      {err ? <Entry submitForm={auth} error={err} id={id} /> : children}
    </AuthSubjectContext.Provider>
  )
}
